import { useQuery } from "react-query";
import { getGuide } from "../requests/getGuide";

export default function useGetGuide(dealerId: string) {
  return useQuery({
    queryKey: ["dealer", { dealerId }],
    queryFn: () => getGuide(dealerId),
    refetchOnWindowFocus: false,
    enabled: Boolean(dealerId),
  });
}
